export const userToken = state => state.authToken;
export const clientToken = state => state.clientToken;
export const loginPosData = state => state.loginPosData;

export const isAuth = state => {
  return state.authToken !== null;
};

export const pdv = state => {
  return state.pdv;
};

export const pos = state => {
  return state.pos;
};

export const userProps = state => {
  return state.userProps;
};

export const userBilletProps = state => {
  return state.userBilletProps;
};

export const signSteps = state => {
  return state.signSteps;
};

export const isGuestBuyer = state => {
  return state.isGuestBuyer;
};

export const apiUrl = state => {
  return state.api_url;
};

export const storeConfigs = state => {
  return state.storeConfigs;
};

export const store = state => {
  return state.store;
};
